const auth = {
    // Common
    email: 'Email',
    password: 'Password',
    submit: 'Submit',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',

    // Form validation
    emailRequired: 'Email is required',
    emailInvalid: 'Please enter a valid email address',
    passwordRequired: 'Password is required',
    confirmPasswordRequired: 'Confirm your password',

    // OAuth
    continueWithGoogle: 'Continue with Google',
    orContinueWithEmail: 'Or continue with email',

    // Signup
    signup: 'Sign Up',
    signupTitle: 'Sign Up',
    signupSubtitle: 'Create a new account',
    alreadyHaveAccount: 'Already have an account?',
    loginLink: 'Login',
    signupSuccess: 'Registration completed successfully!',
    signupError: 'Error during registration',
    login: 'Login',
    loginTitle: 'Login',
    loginSubtitle: 'Enter your email and password',
    dontHaveAccount: 'Don\'t have an account?',
    signupLink: 'Sign Up',
    forgotPassword: 'Forgot password?',
    loginSuccess: 'Login completed successfully!',
    loginError: 'Error during login',
    passwordReset: 'Reset Password',
    passwordResetTitle: 'Reset Password',
    passwordResetSubtitle: 'Enter your email to reset your password',
    sendResetEmail: 'Send Reset Email',
    backToLogin: 'Back to Login',
    resetEmailSent: 'Reset email sent!',
    resetEmailError: 'Error sending reset email',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    resetPassword: 'Reset Password',
    resetting: 'Resetting...',
    passwordResetSuccess: 'Password reset successfully! Redirecting to login...',
    passwordResetError: 'Error during password reset',
    passwordResetErrorUnverified: 'Unable to reset password. Please verify your email address first.',
    resendVerificationEmail: 'Resend Verification Email',
    verificationEmailSent: 'Verification email sent!',
    verificationEmailError: 'Error sending verification email',
    passwordMismatch: 'Passwords do not match',
    passwordsDoNotMatch: 'Passwords do not match',
    passwordTooShort: 'Password must be at least 6 characters',
    passwordMinLength: 'Please lengthen this text to 6 characters or more (you are currently using {current} characters).',
    fieldRequired: 'This field is required.',

    // Email Verification
    emailVerification: 'Email Verification',
    verifyingEmail: 'Verifying your email address...',
    verifying: 'Verifying...',
    emailNotVerified: 'Please verify your email before logging in. Check your inbox for the verification link.',

    // Google OAuth
    googleAuthentication: 'Google Authentication',
    processingGoogleAuth: 'Processing Google authentication...',
    processing: 'Processing...',
    googleAuthSuccess: 'Google authentication completed successfully!',
    googleAuthFailed: 'Google authentication failed.',
    googleAuthFailedWithCredentials: 'Google authentication failed. Check your credentials and try again.',
    googleAuthCancelled: 'Google authentication cancelled or failed.',
    googleNoCode: 'No authorization code received from Google.',
    googleAuthFailedMessage: 'Google authentication failed. You can try again or return to login.',
    tryAgain: 'Try Again'
};

export default auth;
